/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  Alert, AlertTitle, Box, Typography,
} from '@mui/material';

import { style } from '@/styles/globals';
import ErrorIcon from '@mui/icons-material/Error';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { styled } from '@mui/system';

const Custom = styled(Typography)`
  '&::before': {
    content:'emvuidi';
    width:'5px';
    height:'5px';
    background:'white'
  }
`;

function PayMessagePolicy({ onToPolicyPage, sx, isPayment }: { onToPolicyPage: () => void, sx?: any, isPayment?: boolean }) {
  return (
    <Box
      p={isPayment ? '0' : '1rem'}
      paddingBottom={isPayment ? '0' : '80px'}
      sx={sx}
    >
      <Alert
        sx={{
          p: '1em',
          background: style.color.orange4,
          borderRadius: '6px',
          '& .MuiAlert-icon': {
            marginRight: '23px',
          },
          '& .MuiAlert-message':
          {
            overflow: 'visible',
          },
        }}
        icon={(
          <ErrorIcon
            fontSize="small"
            htmlColor={style.color.orange2}
          />
        )}
        severity="warning"
      >
        <AlertTitle
          color={style.color.orange2}
          sx={{
            ml: '-16px',
            mt: '-1px',
            fontWeight: '700',
          }}
        >
          {VN.ALERT_TITLE}
        </AlertTitle>
        <Custom
          variant="body2"
          sx={{
            position: 'relative',
            '::before': {
              content: '""',
              width: 7,
              height: 7,
              background: style.color.orange2,
              borderRadius: '50%',
              position: 'absolute',
              left: -16,
              top: 6,
            },
          }}
          color={style.color.orange2}
        >
          <span>
            {VN.ALERT_PAYMENT}
            {' '}
            <span
              onClick={onToPolicyPage}
              style={{
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              {VN.ALERT_VEXERE}
            </span>
          </span>
        </Custom>

        <Custom
          sx={{
            position: 'relative',
            ...style.text.content.regular,
            '::before': {
              content: '""',
              width: 7,
              height: 7,
              background: style.color.orange2,
              borderRadius: '50%',
              position: 'absolute',
              left: -16,
              top: 6,
            },
          }}
          variant="body2"
          color={style.color.orange2}
        >
          {VN.MESSAGE_PAYMENT}
          {' '}
          <span
            onClick={onToPolicyPage}
            style={{
              color: style.color.orange2,
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            {VN.MESSAGE_POLICY}
            {' '}
            {VN.MESSAGE_GOYOLO}
          </span>
        </Custom>
      </Alert>
    </Box>
  );
}
enum VN {
  ALERT_TITLE = 'Lưu ý:',
  ALERT_PAYMENT = 'Bạn sẽ thanh toán trực tiếp vào tài khoản',
  ALERT_VEXERE = 'VeXeRe - Công ty chủ quản của Goyolo',
  MESSAGE_PAYMENT = 'Bằng việc bấm nút Thanh toán, bạn đã đồng ý với',
  MESSAGE_POLICY = 'Chính sách bảo mật',
  MESSAGE_GOYOLO = 'của Goyolo',
}

export default PayMessagePolicy;
